import ManagedTeam from './ManagedTeam';

export default ManagedTeam;
